<template>
  <div>
    <h1>SPLOŠNI POGOJI POSLOVANJA</h1>
    <p>
      Spletno platformo expar-store.com upravlja Hriberšek storitve, trgovina, tehnično svetovanje, Mitja Krajnc s.p.,  Šmartno v Rožni Dolini 21a, 3201 Šmartno v Rožni dolini, matična številka:
      8564914000, ID za DDV: SI92189407, vpisan v Poslovni register Slovenije
      dne 10. 12. 2019, bančni račun: DE04 1001 1001 2622 4346 09 (BIC: NTSBDEB1XXX), Banka N26
      d.d., v nadaljevanju: Hriberšek Mitja Krajnc s.p. ali expar-store.com). Za poslovne
      odnose med Hriberšek Mitja Krajnc s.p. in naročnikom veljajo izključno Splošni pogoji
      poslovanja, navedeni v nadaljevanju. Ti Splošni pogoji poslovanja so
      sestavljeni v skladu z veljavnim Zakonom o varstvu potrošnikov, Zakonom o
      varstvu osebnih podatkov, Splošno uredbo o varstvu podatkov (GDPR) ter
      Zakonom o elektronskih komunikacijah. Splošne pogoje poslovanja lahko
      naročnik za namene naročila preko spleta shrani na svoj računalnik in/ali
      natisne. Splošni pogoji poslovanja obravnavajo delovanje spletne strani
      www.expar-store.com, pravice naročnika ter njegov poslovni odnos z Hriberšek Mitja Krajnc s.p.
    </p>
    <p>Za največje zadovoljstvo naših kupcev skrbimo predvsem:</p>
    <ul>
      <li>s skrbnim in ažurnim vnosom točnih informacij o naši ponudbi</li>
      <li>
        z zavedanjem za tehnično in pravno varnost naših obiskovalcev in kupcev
      </li>
      <li>
        s posluhom za potrebe naših strank in s prizadevanjem za reševanje
        morebitnih težav, nesporazumov in zapletov
      </li>
      <li>
        z razpoložljivostjo za dodatna pojasnila ter pomočjo tako pred nakupom,
        med nakupom in v času po nakupu.
      </li>
    </ul>
    <h2>Pogodbeni partner in naročnik</h2>
    <p>
      Naročnik je za potrebe teh Splošnih pogojev poslovanja vsak uporabnik
      spletne platforme www.expar-store.com, ki ustvari račun in po preteku 30 dnevnega preiskusnega obdobja plača uporabo.Pogodbeni partner naročnika je Hriberšek Mitja Krajnc s.p.
    </p>
    <h2>Podpora kupcem</h2>
    <p>
      Prodajni svetovalci smo dosegljivi na tel.: 041 619 698 ali na e-naslov
      ziga.coz@linking-map.com.
    </p>
    <h2>Dostopnost informacij</h2>
    <p>(povzetek zakonodaje)</p>
    <p>
      Ponudnik se zavezuje, da bo kupcu vselej zagotovil naslednje informacije:
    </p>
    <ul>
      <li>identiteto podjetja (ime in sedež podjetja, številka registra),</li>
      <li>
        kontaktne podatke, ki uporabniku omogočajo hitro in učinkovito
        komunikacijo (e-pošta, telefon),
      </li>
      <li>
        bistvene značilnosti blaga oziroma storitev (vključno s poprodajnimi
        storitvami in garancijami),
      </li>
      <li>
        dostopnost storitev, ki so v ponudbi na
        spletnem mestu,
      </li>
      <li>
        pogoje izvršitve storitve (način, kraj in rok
        dostave),
      </li>
      <li>
        vse cene morajo biti jasno in nedvoumno določene in razvidno mora biti
        prikazano, ali že vsebujejo davke,
      </li>
      <li>način plačila,</li>
      <li>časovno veljavnost ponudbe,</li>
      <li>
        rok, v katerem je še možno odstopiti od pogodbe in pogojih za odstop;
      
      </li>
      <li>
        pojasnilo postopka ob pritožbi, vključno z vsemi podatki o kontaktni
        osebi ali službi za stike s kupci.
      </li>
    </ul>
    <h2>Ponudba artiklov</h2>
    <p>
      Zaradi narave poslovanja prek svetovnega spleta se ponudba na spletni
      strani expar-store.com dopolnjuje in spreminja. Cene so predstavljene
      kot redne cene in akcijske cene. Redne cene so priporočene prodajne cene
      ponudnika namestitev ali cene, ki jih oblikuje ponudnik sam.
    </p>
    <h2>Povpraševanje po izbrani namestitvi</h2>
    <p>
      Naročnik pri expar-store.com izpolni obrazec - Rezerviraj, ki je v
      primeru prostega termina avtomatsko posredovan ponudniku namestitve.
      Ponudnik namestitve nato avtomatsko prejme povpraševanje in odgovori
      naročniku. Hriberšek Mitja Krajnc s.p. ni odgovoren za ažurnost in točnost odgovora
      izbranega ponudnika namestitve.
    </p>
    <h2>Odstop od pogodbe - vračilo</h2>
    <p>
      Uporabnik ima pravico odstopiti kadarkoli od pogodbe z odjavo aktivnega plana v nadzorni plošči.
    </p>
    <h2>Zaščita podatkov, varstvo podatkov</h2>
    <p>
      Hriberšek Mitja Krajnc s.p. hrani za nedoločen čas sledeče podatke naročnikov: ime in
      priimek, elektronski naslov naročnika, primarni naslov in naslove za
      dostavo, državo prebivališča, čas in datum registracije, elektronske
      naslove za morebitno elektronsko dostavo darilnih bonov, kontaktni
      telefon, pretekla naročila in arhiv komunikacije z Hriberšek Mitja Krajnc s.p.
      <br /><br />Naročnik se izrecno strinja z zbiranjem, obdelavo in uporabo
      svojih osebnih podatkov. Hriberšek Mitja Krajnc s.p. bo z vsemi podatki ravnalo zaupno. Hriberšek Mitja Krajnc s.p. je v skladu z veljavnim Zakonom o varstvu osebnih podatkov ter
      Splošno uredbo o varstvu podatkov (GDPR), zavezano k varovanju osebnih
      podatkov svojih uporabnikov. Hriberšek Mitja Krajnc s.p., ki je lastnik in upravlja spletno
      stran www.expar-store.com, uporablja pri izvajanju svojih storitev
      ustrezno programsko opremo ter zagotavlja vse potrebne tehnološke in
      organizacijske rešitve za popolno varnost nakupa. <br /><br />
      Upravitelj podatkov, podjetje Hriberšek Mitja Krajnc s.p., je odgovorno za varovanje
      osebnih podatkov in bo le-te uporabljal za pošiljanje ponudb, računov,
      trženjskih aktivnosti in ostalo komunikacijo. V nobenem primeru podatki
      naročnika ne bodo posredovani tretji osebi ali nepooblaščeni osebi.
      Dostavni službi se zaupajo le uporabnikov naslov za dostavo. Naročnik je
      odgovoren sam za varovanje podatkov, tako da poskrbi za varnost svojega
      uporabniškega imena in gesla. Ostale določbe v zvezi z varstvom podatkov
      so navedene na spletni strani www.expar-store.com. Naročnik ima vedno
      pravico preklicati soglasje z učinkom za prihodnost. Hriberšek Mitja Krajnc s.p. se
      obvezuje, da bo v primeru preklica nemudoma izbrisalo vse osebne podatke,
      razen če postopek naročila še ni bil do konca izpeljan. Z vpisom
      telefonske številke si pridržujemo pravico, da jo uporabimo za namene
      obveščanja o izpolnitvi ali v povezavi z izpolnitvijo naročila ter ostalo
      potrebno komunikacijo z naročnikom. Z vpisom in potrditvijo vašega
      elektronskega naslova, si pridružujemo pravico za obveščanje v povezavi z
      nedokončanimi nakupi.
    </p>
    <h2>Avtorske pravice, kazensko pravo</h2>
    <p>
      Pri vseh naročilih, zaupanih Hriberšek Mitja Krajnc s.p. se predvidevajo potrebne avtorske
      pravice, pravice do znamk in druge pravice. Odgovornost za morebitne
      posledice, nastale zaradi kršitve teh pravic, nosi izključno naročnik.
      Naročnik s predajo naročila zagotavlja, da vsebine ne kršijo kazenskega
      prava.
    </p>
    <h2>Odveza odgovornosti</h2>
    <p>
      Hriberšek Mitja Krajnc s.p. se bo trudil v sodelovanju s ponudnikom namestitve / doživetja
      zagotavljati ažurnost in pravilnost podatkov namestitev / doživetij, ki so
      objavljena na spletni strani www.expar-store.com. Kljub temu, pa so
      možna razhajanja med ceno navedeno na spletni strani www.expar-store.com
      ter ponudnikom doživetij. Hriberšek Mitja Krajnc s.p. za to ne sprejema odgovornosti.
      Morebitna neskladja naj se sporočijo na etn@turnsek.net, da se napaka
      nemudoma odpravi. Vse fotografije namestitev / doživetij na spletni strani
      www.expar-store.com so zgolj simbolične in ne nujno zagotavljajo
      lastnosti namestitve / doživetja. Hriberšek Mitja Krajnc s.p. ne uporablja oz. ni zavezano
      k uporabi kodeksov ravnanja.
    </p>
    <h2>Reševanje pritožb</h2>
    <p>
      V primeru pritožb, se lahko naročnik poveže po elektronski pošti z Hriberšek Mitja Krajnc s.p., kjer bodo poskrbeli, da bo njegova pritožba na učinkovit in hiter
      način obravnavana. Vsaka prejeta pritožba s strani naročnika bo slednjemu
      najkasneje v petih delovnih dneh potrjena kot prejeta. Ob potrditvi
      prejema se bodo naročniku tudi podal okvirni datum reševanja pritožbe, kot
      tudi informacije v zvezi s kasnejšim seznanjanjem s potekom pritožbenega
      postopka.
    </p>
    <h2>Kraj izpolnitve, sodna pristojnost in uporabno pravo</h2>
    <p>
      Morebitne spore se bosta naročnik in Hriberšek Mitja Krajnc s.p. trudila rešiti sporazumno,
      v nasprotnem primeru pa bo o njih odločalo Okrajno oziroma Okrožno sodišče
      v Celju. V primeru pravnih sporov v zvezi s tem poslovnim razmerjem se
      uporablja izključno slovensko pravo.
    </p>
    <h2>Izvensodno reševanje potrošniških sporov</h2>
    <p>
      Skladno z zakonskimi normativi Hriberšek Mitja Krajnc s.p. ne priznava nikakršnega
      izvajalca izvensodnega reševanja potrošniških sporov kot pristojnega za
      reševanje potrošniškega spora, ki bi ga potrošnik lahko sprožil v skladu z
      Zakonom o izvensodnem reševanju potrošniških sporov. <br />
      <br />Hriberšek Mitja Krajnc s.p., ki kot ponudnik blaga in storitev omogoča spletno
      trgovino, na svoji spletni strani objavlja elektronsko povezavo na
      platformo za spletno reševanje potrošniških sporov (SRPS). Platforma je na
      voljo potrošnikom tukaj.
      https://webgate.ec.europa.eu/odr/main/index.cfm?event=main.home.show&lng=SL
      Navedena ureditev izhaja iz Zakona o izvensodnem reševanju potrošniških
      sporov, Uredbe (EU) št. 524/2013 Evropskega parlamenta in Sveta o spletnem
      reševanju potrošniških sporov ter spremembi Uredbe (ES) št. 2016/2004 in
      Direktive 2009/22/ES
    </p>
    <br />
    <br />
    <br />
    <p>
      Zadnja posodobitev Splošnih pogojev poslovanja: 24. november 2021. 
    </p>
  </div>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: this.$i18n.t('generalTerms'),
    }
  },
  //   nuxtI18n: {
  //     paths: {
  //       sl: "/politika-zasebnosti", // -> mydomain.com/en/politika-zasebnosti
  //       en: "/privacy-policy", // -> mydomain.com/en/privacy-policy
  //     },
  //   },
};
</script>

<style scoped>
h1 {
  font-size: 3em;
  line-height: 1.5em;
  margin: 1em;
}
h2 {
  font-size: 2.4em;
  font-weight: 600;
  line-height: 1em;
  margin: 0.5em;
}
h3 {
  font-size: 1.7em;
  line-height: 0.8em;
  margin: 0.4em;
}
h4 {
  font-size: 1.4em;
  line-height: 0.6em;
  margin-top: 1.5em;
}
p {
  font-size: 1.3em;
  line-height: 1.5em;
  text-align: justify;
  margin-left: 10em;
  margin-right: 10em;
}
li {
  font-size: 1.3em;
  line-height: 1.5em;
  text-align: left;
  margin-left: 20em;
  margin-right: 10em;
  list-style-type: square;
}

th {
  font-size: 1.3em;
  line-height: 1.5em;
  text-align: left;
}
td {
  font-size: 0.6em;
  line-height: 1.5em;
  text-align: left;
}
table {
  margin-left: 15em;
}

@media screen and (max-width: 680px) {
  .privacy {
    margin: 0;
  }
  h1 {
    font-size: 2.5em;
    line-height: 1em;
    margin: 1em;
  }
  h2 {
    font-size: 1.7em;
    font-weight: 600;
    line-height: 1.2em;
    margin: 0.4em;
  }
  h3 {
    font-size: 1.6em;
    line-height: 1.2em;
    margin: 0.4em;
  }
  h4 {
    font-size: 1.4em;
    line-height: 1em;
    margin-top: 1.5em;
  }
  p {
    font-size: 1em;
    line-height: 1.5em;
    text-align: justify;
    margin: 20px;
    word-wrap: break-word;
  }
  li {
    font-size: 1em;
    line-height: 1.5em;
    text-align: left;
    margin-left: 3em;
    margin-right: 1em;
    list-style-type: square;
  }

  th {
    font-size: 1em;
    line-height: 1em;
    text-align: left;
    padding-bottom: 1.5em;
  }
  td {
    font-size: 0.65em;
    line-height: 1.6em;
    text-align: left;
    padding-bottom: 1.5em;
  }
  table {
    margin: 1em;
  }
}
</style>
